import * as z from "zod";

export const templateColumnNameSchema = z.enum([
  "id",
  "label",
  "name",
  "created_at",
  "theme",
  "author",
  "regions",
  "status",
  "actions",
]);

export type TemplateColumnName = z.infer<typeof templateColumnNameSchema>;

export const templatesFilterNameSchema = z.enum([
  "name",
  "label",
  "author",
  "regions",
  "status",
  "archived",
]);

export const templatesOptionalFilterNameSchema = z.enum([
  "id",
  "created_at",
  "theme",
  "keyword",
]);
